import { render, staticRenderFns } from "./AddTagDialog.vue?vue&type=template&id=6cded2a2&scoped=true&"
import script from "./AddTagDialog.ts?vue&type=script&lang=ts&"
export * from "./AddTagDialog.ts?vue&type=script&lang=ts&"
import style0 from "./add-tag-dialog.scss?vue&type=style&index=0&id=6cded2a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cded2a2",
  null
  
)

export default component.exports